
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import { UIRouterModule } from '@uirouter/angular';
import { LoginStates } from './login.states';
import { LoginComponent } from './login.component';
import { ForgotPasswordComponent } from "./forgot-password.component";
import { ResetPasswordComponent } from "./reset-password.component";
import {LaddaModule} from 'angular2-ladda';
import {LoginShellComponent} from './login-shell.component';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import { LoadingComponent } from './loading/loading.component';
import { EdlAuthServicesModule, EdlCommonAuthenticationModule} from '@edl-development/edl-auth';


@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        UIRouterModule.forChild({
            states: LoginStates
        }),
        LaddaModule,
        ReactiveFormsModule,
        NgbModule,

        EdlAuthServicesModule,
        EdlCommonAuthenticationModule
    ],
    declarations: [
        LoginShellComponent,
        LoginComponent,
        ForgotPasswordComponent,
        ResetPasswordComponent,
        LoadingComponent
    ]
})
export class LoginModule {

}
